import {
  rfqSourceInviteListSchema,
  rfqSourceInviteSchema,
  type ConfirmRfqSourceInviteRequest,
  type CreateRfqSourceInviteRequest,
  type RfqSourceInvite,
} from '@console/types'
import { apiDelete, apiGet, apiPost } from '../api.js'

export async function fetchRfqSourceInvites(tenantId: string): Promise<RfqSourceInvite[]> {
  return apiGet(
    `/tenants/${encodeURIComponent(tenantId)}/rfq-source-invites`,
    rfqSourceInviteListSchema,
  )
}

export async function createRfqSourceInvite(
  tenantId: string,
  body: CreateRfqSourceInviteRequest,
  csrfToken: string,
): Promise<RfqSourceInvite> {
  return apiPost(
    `/tenants/${encodeURIComponent(tenantId)}/rfq-source-invites`,
    body,
    csrfToken,
    rfqSourceInviteSchema,
  )
}

export async function confirmRfqSourceInvite(
  inviteId: string,
  body: ConfirmRfqSourceInviteRequest,
  csrfToken: string,
): Promise<RfqSourceInvite> {
  return apiPost(
    `/rfq-source-invites/${encodeURIComponent(inviteId)}/confirm`,
    body,
    csrfToken,
    rfqSourceInviteSchema,
  )
}

export async function revokeRfqSourceInvite(
  inviteId: string,
  csrfToken: string,
): Promise<RfqSourceInvite> {
  return apiDelete(
    `/rfq-source-invites/${encodeURIComponent(inviteId)}`,
    csrfToken,
    rfqSourceInviteSchema,
  )
}
